/* eslint-disable @typescript-eslint/no-empty-function */
import { CheckoutProviderProps } from '@/pages/Checkout/types/paymentLinkContextTypes';

const initialUserState = {
  name: '',
  birth_date: '',
  cpf: '',
  email: '',
  phone: '',
  state: '',
  city: '',
  district: '',
  complement: '',
  number: '',
  street: '',
  cep: '',
  card_number: '',
  card_valid_date: '',
  card_client_name: '',
  card_cvv: '',
  installments: '',
};

const stepsConfig = {
  web: {
    personal: 1,
    address: 2,
    credit: 3,
  },
  mobile: {
    details: 1,
    personal: 2,
    address: 3,
    credit: 4,
  },
};

const initialState: CheckoutProviderProps = {
  currentStep: '0',
  disabledFields: [],
  errorRedirect: '',
  getByCep: async () => {},
  getCurrentStepNumber: () => 0,
  getLinkIsLoading: false,
  getSimulationData: null,
  handleClearCardFields: () => {},
  installmentsOptions: [],
  isMobile: false,
  loadingCEP: false,
  maxSteps: 3,
  paymentLinkData: null,
  postIsLoading: false,
  setCurrentStep: () => {},
  setPostErrorData: () => {},
  setUserData: () => {},
  showAddressFields: false,
  submitCheckout: async () => {},
  submitCheckoutWallet: async () => {},
  userData: initialUserState,
  digitalWalletEnabled: false,
  loadingPage: true,
};

const getStepDeviceLength = (key: string) =>
  Object.keys(stepsConfig[key as keyof typeof stepsConfig]).length;

export { initialUserState, initialState, stepsConfig, getStepDeviceLength };
